import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { NoticeComponent } from 'src/app/dialog/notice/notice.component';
import {
    TransactionModel,
    TransactionModelInterface,
    TransactionModelResponse,
} from 'src/app/interface/transaction-model.interface';
import { OpenIdProfileMixin } from 'src/app/mixin/open-id-profile.mixin';
import { PaginatorMixin } from 'src/app/mixin/paginator.mixin';
import { OpenIdService } from 'src/app/service/open-id.service';

class BaseExtend {
    constructor(protected openIdService: OpenIdService) {}
}
const FinalExtended = OpenIdProfileMixin(PaginatorMixin(BaseExtend));

@Component({
    selector: 'app-transaction',
    templateUrl: './transaction.component.html',
    styleUrls: ['./transaction.component.css'],
})
export class TransactionComponent
    extends FinalExtended
    implements AfterViewInit, OnInit
{
    public transactionModels: TransactionModelInterface[] = [];
    public columnHeadings: string[] = [
        'id',
        'transaction_type',
        'reference',
        'amount',
        'sender_receiver',
        'result',
        'refund',
        'comment',
        'created_at',
    ];

    @ViewChild(MatPaginator) public paginator?: MatPaginator;
    public offset = 0;

    constructor(
        private dialog: MatDialog,
        private httpClient: HttpClient,
        openIdService: OpenIdService
    ) {
        super(openIdService);
    }

    ngOnInit(): void {
        this.$openIdReady.subscribe(() => this.getRecords());
    }

    ngAfterViewInit(): void {
        this.handlePaging(this.paginator!, (offset) => this.getRecords(offset));
    }

    private getRecords(offset: number = 0) {
        // see RestictUserFilter in TransactionViewSet
        this.offset = offset;
        let options = {
            params: new HttpParams()
                .set('limit', this.pagingPageSize)
                .set('offset', offset)
                .set('ordering', '-created_at'),
        };

        this.httpClient
            .get<TransactionModelResponse>('transactions/', options)
            .subscribe((response: TransactionModelResponse) => {
                this.pagingItemCount = response.count;
                this.transactionModels = response.results;
            });
    }

    public reload() {
        this.getRecords(this.offset);
    }

    public showComment(transactionModel: TransactionModel) {
        this.dialog.open(NoticeComponent, {
            data: { message: transactionModel.comment, class: 'none' },
        });
    }
}
